import './element.closest';
import './element.attachEvent';
import './element.getAttribute';
import './string.includes';
import 'classlist-polyfill';
if (!window.URLSearchParams) {
    window.URLSearchParams = require('@ungap/url-search-params');
}
